module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "trialPage"
  }, [(_vm.loading) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm10": "",
      "md10": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary",
      "width": 7,
      "size": 70
    }
  })], 1)], 1) : _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center mb-4",
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('h1', {
    staticClass: "mt-3 mb-4 text-xs-center trialtitle"
  }, [_c('div', {
    staticClass: "status"
  }, [_c('span', {
    class: _vm.trial.trialEnrollment
  })]), _vm._v(" "), _c('div', {
    staticClass: "status"
  }, [_c('span', {
    class: _vm.enrollmentsss.enrollmentName
  })]), _vm._v(" "), _c('span', [_vm._v("Edit " + _vm._s(_vm.trial.trialName))]), _vm._v(" "), (_vm.userIsAuthenticated) ? [_c('app-edit-trial-details-dialog', {
    attrs: {
      "trial": _vm.trial
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('v-expansion-panel', {
    attrs: {
      "expand": "",
      "ripple": ""
    }
  }, [_c('v-expansion-panel-content', {
    attrs: {
      "lazy": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("location_on")]), _vm._v("Location")], 1), _vm._v(" "), _c('v-card', [_vm._l((_vm.locationsss), function(item) {
    return (_vm.trial.trialLocations) ? _c('v-card-text', {
      key: item.locationID,
      staticClass: "white"
    }, [_vm._v("\n              " + _vm._s(item.locationName)), _c('br')]) : _vm._e()
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-card-text', {
    staticClass: "cyanLight editDialogsRow"
  }, [(_vm.userIsAuthenticated) ? [_c('v-spacer'), _vm._v(" "), _c('app-edit-trial-locations-dialog', {
    attrs: {
      "trial": _vm.trial
    }
  })] : _vm._e()], 2) : _vm._e()], 2)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', {
    attrs: {
      "expand": ""
    }
  }, [_c('v-expansion-panel-content', {
    attrs: {
      "lazy": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("loyalty")]), _vm._v("Indications")], 1), _vm._v(" "), _c('v-card', [_vm._l((_vm.indicationsss), function(item, index) {
    return _c('v-card-text', {
      key: ("item-" + index),
      staticClass: "white"
    }, [_vm._v("\n              " + _vm._s(item.indicationName)), _c('br')])
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-card-text', {
    staticClass: "cyanLight editDialogsRow"
  }, [(_vm.userIsAuthenticated) ? [_c('v-spacer'), _vm._v(" "), _c('app-edit-trial-indications-dialog', {
    attrs: {
      "trial": _vm.trial
    }
  })] : _vm._e()], 2) : _vm._e()], 2)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', {
    attrs: {
      "expand": ""
    }
  }, [_c('v-expansion-panel-content', {
    attrs: {
      "lazy": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("person_outline")]), _vm._v("Coordinators")], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "white"
  }, [_c('v-list', _vm._l((_vm.coordinatorsGetter), function(item, index) {
    return _c('v-list-tile', {
      key: ("item-" + index)
    }, [_c('v-list-tile-content', [_vm._v("\n                    " + _vm._s(item.coordinatorName) + "\n                  ")]), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": "",
        "href": 'tel:' + item.coordinatorPhone
      }
    }, [_c('v-icon', {
      attrs: {
        "color": item.active ? 'primary' : 'grey lighten-2'
      }
    }, [_vm._v("phone")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": "",
        "href": 'sms:' + item.coordinatorPhone
      }
    }, [_c('v-icon', {
      attrs: {
        "color": item.active ? 'primary' : 'grey lighten-2'
      }
    }, [_vm._v("textsms")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": "",
        "href": 'mailto:' + item.coordinatorEmail
      }
    }, [_c('v-icon', {
      attrs: {
        "color": item.active ? 'primary' : 'grey lighten-2'
      }
    }, [_vm._v("email")])], 1)], 1)], 1)
  }))], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-card-text', {
    staticClass: "cyanLight editDialogsRow"
  }, [(_vm.userIsAuthenticated) ? [_c('v-spacer'), _vm._v(" "), _c('app-edit-trial-coordinators-dialog', {
    attrs: {
      "trial": _vm.trial
    }
  })] : _vm._e()], 2) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', {
    attrs: {
      "expand": ""
    }
  }, [_c('v-expansion-panel-content', {
    attrs: {
      "lazy": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("person_outline")]), _vm._v("Investigators")], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "white"
  }, [_c('v-list', _vm._l((_vm.investigatorsGetter), function(item, index) {
    return _c('v-list-tile', {
      key: ("item-" + index)
    }, [_c('v-list-tile-content', [_vm._v("\n                    " + _vm._s(item.investigatorName) + "\n                  ")]), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": "",
        "href": 'tel:' + item.investigatorPhone
      }
    }, [_c('v-icon', {
      attrs: {
        "color": item.active ? 'primary' : 'grey lighten-2'
      }
    }, [_vm._v("phone")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": "",
        "href": 'sms:' + item.investigatorPhone
      }
    }, [_c('v-icon', {
      attrs: {
        "color": item.active ? 'primary' : 'grey lighten-2'
      }
    }, [_vm._v("textsms")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": "",
        "href": 'mailto:' + item.investigatorEmail
      }
    }, [_c('v-icon', {
      attrs: {
        "color": item.active ? 'primary' : 'grey lighten-2'
      }
    }, [_vm._v("email")])], 1)], 1)], 1)
  }))], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-card-text', {
    staticClass: "cyanLight editDialogsRow"
  }, [(_vm.userIsAuthenticated) ? [_c('v-spacer'), _vm._v(" "), _c('app-edit-trial-investigators-dialog', {
    attrs: {
      "trial": _vm.trial
    }
  })] : _vm._e()], 2) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', {
    attrs: {
      "expand": ""
    }
  }, [_c('v-expansion-panel-content', {
    attrs: {
      "lazy": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("description")]), _vm._v("Description")], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "white"
  }, [_vm._v("\n              " + _vm._s(_vm.trial.trialDescription)), _c('br')]), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-card-text', {
    staticClass: "cyanLight editDialogsRow"
  }, [(_vm.userIsAuthenticated) ? [_c('v-spacer'), _vm._v(" "), _c('app-edit-trial-details-dialog', {
    attrs: {
      "trial": _vm.trial
    }
  })] : _vm._e()], 2) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', {
    attrs: {
      "expand": ""
    }
  }, [_c('v-expansion-panel-content', {
    attrs: {
      "lazy": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("location_on")]), _vm._v("Address")], 1), _vm._v(" "), _c('v-card', [_vm._l((_vm.locationsss), function(item) {
    return _c('v-card-text', {
      key: item.locationID,
      staticClass: "white"
    }, [_c('strong', [_vm._v(_vm._s(item.locationName))]), _c('br'), _vm._v("\n              " + _vm._s(item.locationStreetAddress)), _c('br'), _vm._v("\n              " + _vm._s(item.locationCity) + ", " + _vm._s(item.locationState) + " " + _vm._s(item.locationZipcode) + "\n            ")])
  }), _vm._v(" "), _c('v-divider')], 2)], 1)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-4 alt--text text--darken-3",
    attrs: {
      "depressed": "",
      "color": "alt lighten-5",
      "dark": "",
      "href": _vm.trial.trialLink,
      "target": "_blank"
    }
  }, [_vm._v("ClinicalTrials.gov")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-4 red darken-3",
    attrs: {
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.onDeleteTrial(_vm.trial)
      }
    }
  }, [_c('v-icon', {
    staticClass: "text--lighten-1",
    attrs: {
      "small": "",
      "dark": ""
    }
  }, [_vm._v("delete")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4331168e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Trials/Edit/EditTrial.vue
// module id = 675
// module chunks = 1